import { render } from "./priceBoxCar.vue?vue&type=template&id=55ce8811&scoped=true"
import script from "./priceBoxCar.vue?vue&type=script&lang=js"
export * from "./priceBoxCar.vue?vue&type=script&lang=js"

import "./priceBoxCar.vue?vue&type=style&index=0&id=55ce8811&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ce8811"]])

export default __exports__